<span class="input-name">{{name}}</span>
<div class="input-container mt-0">      
  <app-input [requiredExternalTrigger]="required" [disabled]="!!disabled" [(value)]="value"
  [inputTypePattern]="InputTypePattern.digitsOnly" (valueChange)="onChange()">
  </app-input>
  <div class="value-type" [ngClass]="{'value-type-required' : required && !disabled}">{{ valueType }}</div>
</div>
